import React from "react";
import * as Styled from "./SecurityStyled";
import Image from "next/image";

const Security = () => {
    return (
        <React.Fragment>
            <Styled.SecurityWrapper id={'security-wrapper'}>
                <Styled.SecurityRow>
                    <Styled.SecurityTitle>
                        Güvenlik
                    </Styled.SecurityTitle>
                    <Styled.SecurityText>
                        <Image src={'/next/assets/images/about-us/ssl.svg'} width={54} height={71} alt={'ssl'}/>
                        <p>
                            Güvenliğiniz için tüm bilgiler SSL (Secure Sockets Layer) protokolü kapsamında şifrelenir.
                        </p>
                    </Styled.SecurityText>
                </Styled.SecurityRow>
                <Styled.SecurityRow>
                    <Styled.SecurityBgImage/>
                </Styled.SecurityRow>
            </Styled.SecurityWrapper>
        </React.Fragment>


    )
}


export default Security;
